import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StakeHolderDetails from "../components/Shareholders";

const ShareholderPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Stakeholder' />

        {/* BlankPageLayer */}
        <StakeHolderDetails />
      </MasterLayout>
    </>
  );
};

export default ShareholderPage;
